const foodMenu = [
	{
		foodImg: 'https://i.ibb.co/Rp5pTdp/main-1.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Main Dish',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/BTkKbZk/main-2.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$30',
		category: 'Main Dish',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/HC19CpW/main-3.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$20',
		category: 'Main Dish',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/Fq7txbQ/main-4.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$15',
		category: 'Main Dish',
		isFeatured: true,
	},
	{
		foodImg: 'https://i.ibb.co/gvbB8Gz/main-5.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Main Dish',
		isFeatured: true,
	},
	{
		foodImg: 'https://i.ibb.co/f8HSbFC/main-6.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Main Dish',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/4Fz39wS/main-7.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Main Dish',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/p4D9rjz/main-8.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Main Dish',
		isFeatured: true,
	},

	{
		foodImg: 'https://i.ibb.co/Z87rhhq/dessert-1.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Dessert',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/jv3S7gr/dessert-2.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Dessert',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/ry7rbJK/dessert-3.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Dessert',
		isFeatured: true,
	},
	{
		foodImg: 'https://i.ibb.co/6t6HyKK/dessert-4.png',
		foodName: 'Kebab Ala Mode',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$25',
		category: 'Dessert',
		isFeatured: false,
	},

	{
		foodImg: 'https://i.ibb.co/pZ2fpDD/drink-1.png',
		foodName: 'Lemonade',
		foodRating: 5,
		foodDesc: 'Lemon juice is an excellent source of Vitamin C.',
		price: '$4',
		category: 'Drink',
		isFeatured: false,
	},
	{
		foodImg: 'https://i.ibb.co/yV0N7Vq/drink-2.png',
		foodName: 'Honey Limeade',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$5',
		category: 'Drink',
		isFeatured: true,
	},
	{
		foodImg: 'https://i.ibb.co/Kh4JCgC/drink-3.png',
		foodName: 'Fresh Watermelon',
		foodRating: 5,
		foodDesc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		price: '$5',
		category: 'Drink',
		isFeatured: false,
	},
];

const reviews = [
	{
		reviewImg: 'https://i.ibb.co/wwJct9M/person-1.png',
		reviewTitle: 'Sarah Miller',
		reviewBody: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		reviewName: 'Jane Doe',
	},
	{
		reviewImg: 'https://i.ibb.co/gDxjqtY/person-2.png',
		reviewTitle: 'Sarah Miller',
		reviewBody: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		reviewName: 'Jane Doe',
	},
	{
		reviewImg: 'https://i.ibb.co/x5VmWBg/person-3.png',
		reviewTitle: 'Sarah Miller',
		reviewBody: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
		reviewName: 'Jane Doe',
	},
];

const chefs = [
	{
		chefImg: 'https://i.ibb.co/mcC2RjD/chef-1.png',
		chefName: 'Sarah Miller',
	},
	{
		chefImg: 'https://i.ibb.co/yFV2W0R/chef-2.png',
		chefName: 'Jackson Smith',
	},
	{
		chefImg: 'https://i.ibb.co/QbKKmy1/chef-3.png',
		chefName: 'Jenny Peterson',
	},
	{
		chefImg: 'https://i.ibb.co/YyN8p2L/chef-4.png',
		chefName: 'Camilla Brown',
	},
	{
		chefImg: 'https://i.ibb.co/pZY8yG4/chef-5.png',
		chefName: 'Ramon Hernandez',
	},
];

export { foodMenu, reviews, chefs };
